import { useContext } from 'react';
import ScoreList from '../../components/leaderboard/score-list';
import { GameContext } from '../../contexts/game';
import { generateTitleById } from '../../utils/game-document/display-languages';
import { GameDocumentContext } from '../../contexts/game-document';
import { DisplayLanguageContext } from '../../contexts/display-languages';
import { ArGameNames } from '../../constants/argame';
import { GameControl } from '../../components/facilitator/game-control';

const LeaderboardPage = () => {
  const [state] = useContext(GameContext);
  const [gameDocument] = useContext(GameDocumentContext);
  const [displayLanguageContext] = useContext(DisplayLanguageContext);

  const isARPyramidGame = ArGameNames.includes(
    gameDocument.gameDocument?.name!
  );

  const isTeamGame =
    gameDocument.gameDocument?.settings.preGame?.isPreGameTeamRequired ??
    ((state.gameState?.teams?.length ?? 0) > (state.gameState?.players?.length ?? 0));

  const leaderboardData = isTeamGame
    ? (state.gameState?.teams && state.gameState.teams.length > 0
        ? state.gameState.teams
        : state.gameState?.players ?? [])
    : (state.gameState?.players && state.gameState.players.length > 0
        ? state.gameState.players
        : state.gameState?.teams ?? []);

  return (
    <div className={'d-flex flex-column mt-10'}>
      {isARPyramidGame && (
        <>
          <div className={'px-4'}>
            <GameControl noBorder />
          </div>
          <hr />
        </>
      )}
      <div className={`text-center mb-8 ${isARPyramidGame ? 'mt-4' : ''}`}>
        <h1 className={'text-primary'}>
          <b>
            {generateTitleById(
              'e698200c-73e4-41e3-b4b1-fa4b38f4638c',
              gameDocument,
              displayLanguageContext.displayLanguageSelected.resources!,
              'game'
            ) || 'Leaderboard'}
          </b>
        </h1>
        <hr />
        <ScoreList
          isHideAvatar={ArGameNames.includes(gameDocument.gameDocument?.name!)}
          data={leaderboardData}
        />
      </div>
    </div>
  );
};

export default LeaderboardPage;
